import { CardHeader as MuiCardHeader } from "@mui/material";

export const CardHeader = (props: any) => {
    return<MuiCardHeader {...props}
    />
  };
